import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import Section from './section';
import {PopperOffsetContext} from '../../../../shared/library/popovers/base-v2';
import {MobileContext} from '../../../../shared/enhancers/mobile-enhancer';
import PrivateTeamCard from '../../../../shared/library/cards/private-teams';
import TechStackIcon from '../../../../shared/library/icons/tech-stacks-icon.svg';
import TeamIcon from '../../../../shared/library/icons/icon-team.svg';
import UtilitiesIcon from '../../../../shared/library/icons/utilities.svg';
import AddItem from '../../../../shared/library/buttons/add-item/index.jsx';
import {OwnerContext} from '../../enhancers/company-profile';

export const query = gql`
  query privateTeams($id: ID!, $orgId: ID, $first: Int, $after: String) {
    company(id: $id) {
      id
      privateTeams(orgId: $orgId, first: $first, after: $after) {
        count
        edges {
          node {
            imageUrl
            id
            name
            description
            canonicalUrl
            privateToolsCount(withoutPackages: true)
            stacksCount
            membersCount
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
`;

const PrivateTeams = ({
  companyId,
  companySlug,
  isAdmin,
  isSiteAdmin,
  isPrivate,
  currentOrg,
  count
}) => {
  const isMobile = useContext(MobileContext);
  const currentUserIsOwner = useContext(OwnerContext);
  return (
    <PopperOffsetContext.Provider value="85px,0">
      <Section
        title="Teams"
        count={count}
        query={query}
        dataKey="privateTeams"
        variables={{id: companyId, orgId: currentOrg && currentOrg.id}}
        initialPageSize={isMobile ? 4 : 6}
        pageSize={10}
        gridCols={isMobile ? 1 : 2}
        privateMode={isPrivate}
        customTitleComponent={
          (isSiteAdmin || (currentUserIsOwner && isAdmin)) && (
            <AddItem addItemTitle="Add team" addItemLink={`${companySlug}/teams`} />
          )
        }
      >
        {({edges}) => {
          return edges.length > 0
            ? edges.map(e => {
                const iconData = [
                  {
                    Icon: <TechStackIcon />,
                    count: e.node.stacksCount,
                    toolTip: 'Stacks'
                  },
                  {
                    Icon: <TeamIcon />,
                    count: e.node.membersCount,
                    toolTip: 'Members'
                  },
                  {
                    Icon: <UtilitiesIcon />,
                    count: e.node.privateToolsCount,
                    toolTip: 'Tools'
                  }
                ];
                return <PrivateTeamCard key={e.node.id} iconData={iconData} team={e.node} />;
              })
            : 'No Private Teams Found!';
        }}
      </Section>
    </PopperOffsetContext.Provider>
  );
};

PrivateTeams.propTypes = {
  companyId: PropTypes.any.isRequired,
  isPrivate: PropTypes.bool,
  companySlug: PropTypes.string,
  isAdmin: PropTypes.bool,
  isSiteAdmin: PropTypes.bool,
  currentOrg: PropTypes.object,
  count: PropTypes.number.isRequired
};

export default PrivateTeams;
